/**
 * Files an upload can't add (an unsupported type, or a transfer that failed)
 * are named when the rest are committed, so one row in a hundred isn't lost.
 */
const NAMED = 3;

export const leftOutDescription = (names: string[]): string | undefined => {
  if (!names.length) return undefined;
  const shown = names.slice(0, NAMED).join(", ");
  const more = names.length > NAMED ? ` and ${names.length - NAMED} more` : "";
  const verb = names.length === 1 ? "wasn't" : "weren't";
  return `${shown}${more} ${verb} added. Save as PDF or Word and upload again.`;
};
